module.exports = __webpack_public_path__ + "1427b184a3055039c3c604725e8f3d9c.png";